import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { SerializedError } from "@reduxjs/toolkit";

interface ErrorForm {
  [key: string | number]: string | string[];
}
interface EntityError {
  status: number;
  data: {
    error: string[];
  };
}
interface FecthError {
  status: string;
  error: string;
}

interface ResponseError {
  error: string[];
  status: number;
}
type s = {
  err: SerializedError;
};
export function isFetchBaseQueryError(
  error: unknown
): error is FetchBaseQueryError {
  return typeof error === "object" && error !== null;
}

export function isEntityError(error: unknown): error is EntityError {
  return (
    isFetchBaseQueryError(error) &&
    typeof error.data === "object" &&
    error.data !== null
  );
}

export function checkEntityError(error: unknown): any {
  return (
    isFetchBaseQueryError(error) &&
    typeof error.data === "object" &&
    error.data !== null
  );
}

export function isFetchError(error: unknown): error is FecthError {
  return (
    isFetchBaseQueryError(error) &&
    typeof error.status === "string" &&
    error.error !== null
  );
}
export function convertErrorUnwrap(error: unknown): ResponseError {
  if (isEntityError(error)) {
    if (typeof error.data.error === "string") {
      return {
        status: Number(error.status),
        error: [error.data.error],
      };
    }
    return {
      status: Number(error.status),
      error: error.data.error,
    };
  } else if (isFetchError(error)) {
    return {
      status: Number(error.status),
      error: [error.status],
    };
  } else {
    return {
      status: 404,
      error: ["CONNECT_ERROR"],
    };
  }
}
